import React from "react";
import { useLocation } from "react-router-dom";
import { getMarketingLanguageFromPath, MarketingLanguage } from "../../marketing-content/marketingLocales";
import { MarketingLoadFailure } from "./MarketingLoadFailure";
import { trackErrorWhenLoaded } from "../../utils/analytics/track-error-when-loaded";

class MarketingResourceBoundary extends React.Component<{
  children: React.ReactNode;
  language: MarketingLanguage;
  pathname: string;
  section?: string;
  fallback?: React.ReactNode;
}, { failed: boolean; pathname: string }> {
  state = { failed: false, pathname: this.props.pathname };
  static getDerivedStateFromProps(props: { pathname: string }, state: { pathname: string }) {
    return props.pathname !== state.pathname ? { failed: false, pathname: props.pathname } : null;
  }
  static getDerivedStateFromError() { return { failed: true }; }
  componentDidCatch(error: Error, info: React.ErrorInfo) {
    trackErrorWhenLoaded(error, { scope: "marketing-page-load", extra: { language: this.props.language, route: this.props.pathname, section: this.props.section || "page", componentStack: info.componentStack?.slice(0, 3000) } });
  }
  render() {
    return this.state.failed ? (this.props.fallback !== undefined ? this.props.fallback : <MarketingLoadFailure language={this.props.language} />) : this.props.children;
  }
}

export function MarketingLoadErrorBoundary({ children, section, fallback }: { children: React.ReactNode; section?: string; fallback?: React.ReactNode }) {
  const { pathname } = useLocation();
  return <MarketingResourceBoundary section={section} fallback={fallback} pathname={pathname} language={getMarketingLanguageFromPath(pathname)}>
    {children}
  </MarketingResourceBoundary>;
}
